module.exports = __webpack_public_path__ + "img/call-to-action-bg.b788518f.svg";